import React, { useEffect } from "react";
import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import SubmitPopup from "../Submitpopup/Submitpopup";

import env from "react-dotenv";
import axios from "axios";
import { API_BASE_URL } from "@/config/serverApiConfig";
import { Modal, Spinner } from "react-bootstrap";
import OtpInput from "react-otp-input";

const Otp = (props) => {
  //const history = useHistory()
  const history = useHistory();

  
  const [submitLoader, setSubmitLoader] = useState(false);
  const [smShow, setSmShow] = useState(false);
  const [resLogin1, setresLogin1] = useState({
    status: "",
    message: "",
    token: "",
    user: {
      status: "",
      role: "",
      _id: "",
      fname: "",
      lname: "",
      email: "",
      city: "",
      country: "",
      phone: "",
      reference: [],
      created: "",
    },
  });



  async function OTP_login(event) {
    setSubmitLoader(true);
    event.preventDefault();

    axios
      .post(`${API_BASE_URL}user/verifyotp`, {
        otp: otp,
        user_id: localStorage.getItem("user_id"),
      })
      .then(function (response) {
        
        setSmShow(true);
        //    setUserID(response.data.data.user_id)

        setSubmitLoader(false);
        setresLogin1(response.data);
        // console.log(response.data);
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        localStorage.setItem("fname", JSON.stringify(response.data.user.fname));
        localStorage.removeItem('user_id');
        //history.push("/user-dashboard");

        //localStorage.setItem("user", JSON.stringify(response.data));
        
       })
      .catch(function (error) {
        setSubmitLoader(false);

      });
  }
  let USERID ="";
 if( props.userID !== undefined|| props.userID !== null || props.userID !== "" || props.userID !== "0") { 
  USERID= props.userID;
}
useEffect(() => {
  // if smShow is true then make is false after 5 seconds
  if (smShow) {
    setTimeout(() => {
      otpmsgClose();
    }
      , 5000);
  }

}, [smShow]);

useEffect (() => {
  USERID= props.userID;
}, [])
  let [otp, setotp] = useState("");
  // otp handler
  const otpmsgClose = () => {
    setSmShow(false);
    history.push("/dashboard");
  }
  const otpHandler = (otp) => setotp(otp);

  async function OTP_register(event) {
    event.preventDefault();
    axios
      .post(`${API_BASE_URL}user/verifyotp-signup`, {
        otp: otp,
        user_id: localStorage.getItem("user_id"),
      })
      .then(function (response) {
        
        setSmShow(true);
        //    setUserID(response.data.data.user_id)
        setSubmitLoader(false);
        setresLogin1(response.data);
        if(response.data.status === "success"){

        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        localStorage.removeItem('user_id');
        }

        //localStorage.setItem("user", JSON.stringify(response.data));
   } 
   

  
  )
      .catch(function (error) {
        setresLogin1(error);
      });
  }



  return (
    <>

<SubmitPopup
        onClose={otpmsgClose}
        show={smShow}
        title={resLogin1.message}
      />
      {/* <Modal
        size="sm"
        show={smShow}
        onHide={otpmsgClose}
        aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Header closeButton className='border-0'></Modal.Header>
        <Modal.Body className='text-center py-5'>
          <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_113_322)">
              <path d="M42.2982 73.7798C61.5168 71.7083 75.4184 54.4594 73.3482 35.2533C71.278 16.0473 54.02 2.15707 34.8014 4.22862C15.5827 6.30017 1.68115 23.5491 3.75134 42.7551C5.82154 61.9611 23.0795 75.8514 42.2982 73.7798Z" fill="#9F7854" />
              <path d="M33.4835 57.1484L18.8401 42.1276L24.3222 36.7842L33.3144 46.0081L53.2186 24.3097L58.8613 29.4841L33.4835 57.1484Z" fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_113_322">
                <rect width="70" height="70" fill="white" transform="translate(0 7.95245) rotate(-6.15208)" />
              </clipPath>
            </defs>
          </svg>
          <p className='pb-3 pt-3'>{resLogin1.message}</p>
        </Modal.Body>
        {/* <Modal.Body>
          <div className="text-center">
            <h4>
              {resLogin1.status === "success" ? (
                <>
                  <span className="text-success">
                    <i className="fa fa-check-circle"></i>
                  </span>{" "}
                  {resLogin1.message}
                </>
              ) : (
                <>
                  <span className="text-danger">
                    <i className="fa fa-times-circle"></i>
                  </span>{" "}
                  {resLogin1.message}
                </>
              )}
            </h4>
          </div>

        </Modal.Body> 
      </Modal> */}

      <section 
         className={USERID  ? "otp_sec" : "otp_sec  disable"}>
        
         
              <form className="otp-form" onSubmit={props.login ? OTP_login : OTP_register } >
          <div className="row">
                <div className="col-lg-3 d-flex align-items-center">
                  <span className="otp_text">Please enter your OTP here:  </span>
                </div>

                <div className="col-lg-9">
                    <OtpInput 
                      value={otp}
                      onChange={otpHandler}
                      numInputs={6}
                    className="text-center form-control rounded p-0 border-0"
                    />
                </div>
                  <div className="mt-5 col mb-5 text-end">
                    <button
                      type="submit"
                      className="btn-full-color px-4 validate"
                    >
                      <Spinner
                        as="span"
                        animation={submitLoader ? "border" : ""}
                        size="sm"
                        role="status"
                        aria-hidden="false"
                      />
                      Validate
                    </button>
                  </div>
          </div>
              </form>
          <SubmitPopup />
      </section>
    </>
  );
};
export default Otp;
